import React, { Component } from 'react';
import { scriberCountsByDay } from '../../../../api';
import Highcharts from 'highcharts/highstock';
import {config4} from "../data";
import BlockUi from 'react-block-ui';
import { Loader } from 'react-loaders';

class IncreaseOrDeleteChart extends Component{
  constructor() {
    super();
    this.state = {
      block: true
    };
  }
  componentDidMount() {
    this.mounted = true;
    scriberCountsByDay({}, {headers: {'tenantname': this.props.name}})
      .then(res=>{
        let data = res.data || {};
        if (this.mounted) {
          this.setState({block: false}, ()=>{
            config4.xAxis.categories = data.dates.split(',');
            config4.series[0].data = data.counts.split(',').map(v=>v-0);

            Highcharts.chart('increaseOrDeleteChart', config4);
          });
        }
      })
      .catch(err=>console.log(err));
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  render() {
    let  { block } = this.state;
    return (
      <div className="tab-pane fade" id="s3">
        <BlockUi tag="div"
                 loader={<Loader active type="ball-grid-pulse" color="#808080"/>}
                 blocking={block}>
          <div id="increaseOrDeleteChart"
               className="chart has-legend"
               style={{height: 400}} />
        </BlockUi>
      </div>
    );
  }
}

export default IncreaseOrDeleteChart;


// WEBPACK FOOTER //
// ./src/container/dashboard/model/charts/increaseOrDeleteChart.js